import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { IMDSSessionProps, IMDSSessionRef } from "./session.types";
import { MDSSessionProvider } from "./session-context";
import { MDSSessionContent } from "@/mds/components/sessions/session-content/session-content";
import { MDSSessionContextValue } from "./session-context/mds-session-context.types";

export const MDSSession = forwardRef<IMDSSessionRef, IMDSSessionProps>((props, ref) => {
  const contextRef = useRef<MDSSessionContextValue | null>(null);

  useImperativeHandle(ref, () => ({
    updateEvent: sessionEvent => {
      contextRef.current?.addSessionEvent(sessionEvent);
    },
    updateEvents: sessionEvents => {
      contextRef.current?.updateSessionEvents(sessionEvents);
    },
    updateStatus: sessionStatus => {
      contextRef.current?.updateSessionStatus(sessionStatus);
    },
    minimizeSession: () => {
      contextRef.current?.minimizeSession();
    },
    expandSession: () => {
      contextRef.current?.expandSession();
    },
    startCountdown: durationMs => {
      contextRef.current?.startCountdown(durationMs);
    },
  }));

  return (
    <MDSSessionProvider
      ref={contextRef}
      initialSessionEvents={props.initialSessionEvents}
      initialSessionStatus={props.initialSessionStatus}
      config={props.config}
      handlers={props.handlers}
    >
      <MDSSessionContent {...props} />
    </MDSSessionProvider>
  );
});
